<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedOption"
      class="tw-min-w-[200px]"
      data-test="tc-filter-hire-history"
      :label="meta.filter.quickFilter ? '' : $t('Previously Hired')"
      :list="options"
      :placeholder="$t('All')"
      can-deselect
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { TrustedContactHireHistory } from '@/gql/graphql'

defineProps<{ meta: FilterMetaDataProp }>()

// The model value should be the full HireHistoryFilterInput object
const model: ModelRef<{ status: TrustedContactHireHistory; accounts: string[] } | null> =
  defineModel({
    default: () => null,
  })

const options = [
  { label: $t('Yes'), value: TrustedContactHireHistory.PreviouslyHired },
  { label: $t('No'), value: TrustedContactHireHistory.NotPreviouslyHired },
]

// Internal state for the select
const selectedOption = computed({
  get: () => {
    if (!model.value?.status) return null
    return options.find((o) => o.value === model.value?.status) ?? null
  },
  set: (option) => {
    if (!option) {
      model.value = null
    } else {
      model.value = {
        status: option.value as TrustedContactHireHistory,
        accounts: [currentAccount.globalId],
      }
    }
  },
})
</script>
